import { addMedia } from "../utils/media-utils";
import { ObjectContentOrigins } from "../object-types";

export function onRemoveMirrorMedia(el) {
  const parentMirror = el.parentEl.parentEl;
  const closeButton = parentMirror.querySelector("[close-mirrored-media-button]");
  parentMirror.object3D.visible = false;
  closeButton.click();
}

export function onPinMirrorMedia(el, deselectObject) {
  deselectObject();
  const src = el.components["media-image"].data.src;
  const contentOrigin = src instanceof File ? ObjectContentOrigins.FILE : ObjectContentOrigins.URL;
  const mediaOptions = {};

  const offset = { x: 0, y: 0, z: -1.5 };

  const { entity, orientation } = addMedia(
    src,
    "#interactable-media",
    contentOrigin,
    src.name === "message.png" ? "message" : null,
    !(src instanceof MediaStream),
    true,
    true,
    mediaOptions
  );

  orientation.then(or => {
    entity.setAttribute("offset-relative-to", {
      target: "#avatar-pov-node",
      offset,
      orientation: or
    });
  });

  entity.addEventListener(
    "media_resolved",
    () => {
      if (!NAF.utils.isMine(entity) && !NAF.utils.takeOwnership(entity)) return;
      window.APP.pinningHelper.setPinned(entity, true);
    },
    { once: true }
  );
  onRemoveMirrorMedia(el);
}

export function isMirrorMedia(el) {
  return el && el.id == "media-mirror-target";
}
